import React from "react";
import Link from "next/link";

import styling from "./BlogHeader.module.scss";
import { UserData } from "@/app/GlobalRedux/features/auth/authInterfaces";

interface MobileNavProps {
  isNavExpanded: boolean;
  isLoggedIn: boolean;
  setIsNavExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  user: UserData;
}

const MobileNav: React.FC<MobileNavProps> = ({
  isLoggedIn,
  isNavExpanded,
  setIsNavExpanded,
  user,
}) => {
  return (
    <nav className={styling.mobilenav}>
      <ul
        className={"mobilenav__list"}
        onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}
      >
        {isLoggedIn && (
          <li>
            <Link
              href="/user-profile"
              style={{
                textDecoration: "none",
                color: "rgb(4, 2, 69)",
                boxShadow: "0 -1px 1px 1px rgb(4, 2, 69)",
                padding: "5px 10px",
                borderRadius: "3px",
                display: "inline-block",
                fontSize: ".8rem",
              }}
            >
              Your Profile
            </Link>
          </li>
        )}
        {!isLoggedIn && <Link href="/auth/signin">Sign In</Link>}
        <li>
          <Link href="/siteinfo/aboutus">About Us</Link>
        </li>
        <li>
          <Link href="https://vinnietec.netlify.app/">VINNIETEC</Link>
        </li>
        {isLoggedIn && (
          <li>
            {user.userIsVerified === true &&
            (user.role === "Super Admin" ||
              user.role === "Admin" ||
              user.role === "Editor") ? (
              <Link href={user.role === "Editor" ? "/admin/posts" : "/admin"}>
                {user.role === "Editor" ? "Editor Panel" : "Admin Panel"}
              </Link>
            ) : (
              ""
            )}
            {user.userIsVerified === true && user.role === "Author" ? (
              <Link href="/author">Author Panel</Link>
            ) : (
              ""
            )}
          </li>
        )}
      </ul>
    </nav>
  );
};

export default MobileNav;
